'use client';

import { Box, SxProps, Typography } from '@mui/material';
import { MuiButton } from '@/components/button/MuiButton';
import { PORTAL_USE_TYPE, isPortalUseType } from '@/types/types';
import { useSearchParams } from 'next/navigation';
import Logo from '@/../public/logo_normal.png';

export function SignupBox() {
  const searchParams = useSearchParams();
  const useTypeParam = parseInt(searchParams.get('use_type') || '2');
  const useType = isPortalUseType(useTypeParam)
    ? useTypeParam
    : PORTAL_USE_TYPE.REQUEST_USER;
  const customCallbackPath = searchParams.get('callbackUrl');
  const callbackUrl = customCallbackPath
    ? `${process.env.NEXT_PUBLIC_IBOW_AUTH_URL}?signin=1&callback_url=${process.env.NEXT_PUBLIC_SITE_URL}${customCallbackPath}`
    : `${process.env.NEXT_PUBLIC_IBOW_AUTH_URL}?signin=1&callback_url=${process.env.NEXT_PUBLIC_SITE_URL}/recept`;
  const TabContentStyle: SxProps = {
    marginTop: -12,
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    mt: -4,
    mb: 4,
  };
  return (
    <Box
      width="100%"
      minHeight="534px"
      maxHeight="100%"
      display="flex"
      flexDirection="column"
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexGrow={1}
        mx={2}
      >
        <Box sx={TabContentStyle}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box
              component="img"
              src={Logo.src}
              alt="けあログっとロゴ"
              sx={{ maxWidth: '300px', margin: '0 auto' }}
            />
            <Typography
              variant="JP/Heading/2xl/Bold/Tight"
              textAlign="center"
              component="p"
              color="primary"
              sx={{
                '@media (max-width: 600px)': { fontSize: '24px' },
              }}
            >
              {useType === PORTAL_USE_TYPE.REQUEST_USER
                ? '利用者を紹介する'
                : '看護・医療の情報を掲載する'}
            </Typography>
            <Typography
              variant="JP/Heading/s/Bold/Tight"
              textAlign="center"
              component="p"
              sx={{ mb: 5, '@media (max-width: 600px)': { fontSize: '16px' } }}
            >
              {useType === PORTAL_USE_TYPE.REQUEST_USER
                ? '介護・医療の事業者職員としてアカウント登録'
                : '訪問看護ステーションの職員としてアカウント登録'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <MuiButton
              href={
                customCallbackPath
                  ? callbackUrl
                  : `${callbackUrl}?use_type=${useType}`
              }
              size="large"
              sx={{ textTransform: 'none' }}
            >
              iBowアカウント登録へ
            </MuiButton>
            <MuiButton
              href={`/signin?use_type=${useType}`}
              variant="text"
              color="secondary"
            >
              ログインはこちらから
            </MuiButton>
            <MuiButton
              href={`/signup?use_type=${
                useType === PORTAL_USE_TYPE.REQUEST_USER
                  ? PORTAL_USE_TYPE.PORTAL_STAFF
                  : PORTAL_USE_TYPE.REQUEST_USER
              }`}
              variant="text"
              color="inherit"
              size="small"
            >
              {useType === PORTAL_USE_TYPE.REQUEST_USER
                ? '訪問看護ステーションの職員としてアカウント登録したい方はこちらから'
                : '介護・医療の事業者職員としてアカウント登録したい方はこちらから'}
            </MuiButton>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
